<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Dashboard-DNA"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="ic_female">
        <circle id="Oval" fill="#1B1E1E" cx="12" cy="12" r="12"></circle>
        <g
          id="female_24dp_FILL1_wght400_GRAD0_opsz24"
          transform="translate(8.4, 6)"
          fill="#95A7A3"
          fill-rule="nonzero"
        >
          <path
            id="Shape"
            d="M3.17647059,12 L3.17647059,10.5882353 L1.76470588,10.5882353 L1.76470588,9.17647059 L3.17647059,9.17647059 L3.17647059,7.69411765 C2.24705882,7.52941176 1.48529412,7.08529412 0.891176471,6.36176471 C0.297058824,5.63823529 0,4.8 0,3.84705882 C0,2.77647059 0.379411765,1.86764706 1.13823529,1.12058824 C1.89705882,0.373529412 2.81176471,0 3.88235294,0 C4.95294118,0 5.86764706,0.373529412 6.62647059,1.12058824 C7.38529412,1.86764706 7.76470588,2.77647059 7.76470588,3.84705882 C7.76470588,4.8 7.46764706,5.63823529 6.87352941,6.36176471 C6.27941176,7.08529412 5.51764706,7.52941176 4.58823529,7.69411765 L4.58823529,9.17647059 L6,9.17647059 L6,10.5882353 L4.58823529,10.5882353 L4.58823529,12 L3.17647059,12 Z M3.88235294,6.35294118 C4.56470588,6.35294118 5.14705882,6.11176471 5.62941176,5.62941176 C6.11176471,5.14705882 6.35294118,4.56470588 6.35294118,3.88235294 C6.35294118,3.2 6.11176471,2.61764706 5.62941176,2.13529412 C5.14705882,1.65294118 4.56470588,1.41176471 3.88235294,1.41176471 C3.2,1.41176471 2.61764706,1.65294118 2.13529412,2.13529412 C1.65294118,2.61764706 1.41176471,3.2 1.41176471,3.88235294 C1.41176471,4.56470588 1.65294118,5.14705882 2.13529412,5.62941176 C2.61764706,6.11176471 3.2,6.35294118 3.88235294,6.35294118 Z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>
